import { gql } from '@apollo/client';
import {
  CustomerInfoFieldsFragment,
  PermissionConfigFieldsFragment,
  SchemaConfigFieldsFragment,
  UserSettingFieldsFragment,
} from '../fragments';
import { FormatSettingFragment } from '../permission/fragments';
import {
  AllowedDomainSettingFragment,
  CustomerPlanFieldsFragment,
  ReportSettingFieldsFragment,
} from './fragments';
import {
  AnalysisFieldsFragment,
  AnalysisMetaFieldsFragment,
} from '../analysis/fragments';

export const GET_GEO_CONFIG = gql`
  query GeoConfig {
    geoConfig {
      mapFileUrl
    }
  }
`;

// GraphQL query "bootstrapQuery" pulls several settings at the time. We can't
// interpolate UserSettingKind values in the query because GraphQL codegen will
// not produce the IBootstrapQueryQuery type because the query is no longer
// static string. Instead of hardcoding these values the query, we better pass
// them as variable (albeit they are constants)
export const bootstrapQuery = gql`
  query BootstrapQuery(
    $jupiterHostKind: UserSettingKind!
    $quickAccessDictionaryKind: UserSettingKind!
    $dashboardSidebarKind: UserSettingKind!
    $executionHistoryExpandedKind: UserSettingKind!
    $defaultViewKind: UserSettingKind!
    $defaultSchemaKind: UserSettingKind!
    $sidebarPinnedKind: UserSettingKind!
    $sidebarSizeKind: UserSettingKind!
    $colorSchemaKind: UserSettingKind!
  ) {
    globalConfig {
      enabledFeatures
      slackSupportLink
      timeUnits
      defaultEnd
      timezone
      preventBasicEventMetadataUpdates
      formatSetting {
        ...FormatSettingFields
      }
      reportSetting {
        ...ReportSettingFields
      }
      llmApiEnabled
    }
    scheduleConfig {
      domains
    }
    jupyterHostSetting: userSetting(kind: $jupiterHostKind) {
      ...UserSettingFields
    }
    quickAccessDictionarySetting: userSetting(
      kind: $quickAccessDictionaryKind
    ) {
      ...UserSettingFields
    }
    dashboardSidebarSetting: userSetting(kind: $dashboardSidebarKind) {
      ...UserSettingFields
    }
    executionHistoryExpandedSetting: userSetting(
      kind: $executionHistoryExpandedKind
    ) {
      ...UserSettingFields
    }
    defaultViewSetting: userSetting(kind: $defaultViewKind) {
      ...UserSettingFields
    }
    defaultSchemaSetting: userSetting(kind: $defaultSchemaKind) {
      ...UserSettingFields
    }
    sidebarPinnedSetting: userSetting(kind: $sidebarPinnedKind) {
      ...UserSettingFields
    }
    sidebarSizeSetting: userSetting(kind: $sidebarSizeKind) {
      ...UserSettingFields
    }
    defaultColorSchemaSetting: userSetting(kind: $colorSchemaKind) {
      ...UserSettingFields
    }
    incidentTypes {
      id
      name
    }
    schemaConfig {
      ...SchemaConfigFields
    }
    permissionConfig {
      ...PermissionConfigFields
    }
    customerInfo {
      ...CustomerInfoFields
    }
    customerPlan {
      ...CustomerPlanFields
    }
  }
  ${SchemaConfigFieldsFragment}
  ${PermissionConfigFieldsFragment}
  ${FormatSettingFragment}
  ${CustomerInfoFieldsFragment}
  ${UserSettingFieldsFragment}
  ${ReportSettingFieldsFragment}
  ${CustomerPlanFieldsFragment}
`;

export const GET_ALLOWED_DOMAIN_SETTING = gql`
  query GetAllowedDomainSetting {
    allowedDomainSetting {
      ...AllowedDomainSettingFields
    }
  }
  ${AllowedDomainSettingFragment}
`;

export const GET_CUSTOMER_PLAN = gql`
  query CustomerPlan {
    customerPlan {
      ...CustomerPlanFields
    }
  }
  ${CustomerPlanFieldsFragment}
`;

export const GET_CUSTOMER_PLAN_MTU_REPORT = gql`
  query CustomerPlanMTUReport($populateBuilder: Boolean = false) {
    customerPlan {
      mtuPlan {
        mtuReport {
          ...AnalysisMetaFields
          ...AnalysisFields
        }
      }
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${AnalysisFieldsFragment}
`;
